// export const getECode = !localStorage.getItem("rsc") ? null : JSON.parse(localStorage.getItem("rsc")).e_code;

// export const getRStage = !localStorage.getItem("rsc") ? null : JSON.parse(localStorage.getItem("rsc")).r_stage;

export const getECode = () => {
  let rsc = localStorage.getItem("rsc");

  if (rsc) {
    return JSON.parse(rsc).e_code;
  }

  return null;
}

export const getRStage = () => {
  let rsc = localStorage.getItem("rsc");

  if (rsc) {
    return JSON.parse(rsc).r_stage;
  }

  return null;
}

export const getToken = localStorage.getItem("token");

export function stageParser(r_stage) {
  switch (r_stage) {
    case "0":
      return "test12"
    case "1":
      return "prod"
    case "8":
      return "staging"
    case "9":
      return "dev"
    case "nil":
      return ""
    default:
      return "dev"
  }
}
